import React from "react";
import { connect, useSelector } from "react-redux";
import axios from "axios";
import Modal from "../common/Modal/Modal";
import InvoiceDetailsCard from "./InvoiceDetailsCard";
import { clearInvoiceVersionDetail } from "../../actions/invoices";

// Read-only look at a single past (superseded) version of an invoice, fetched on
// demand via the same detail endpoint the live invoice page uses -- reuses
// InvoiceDetailsCard so it renders identically to the current invoice, just with
// that version's own field values and attachments.
export function InvoiceVersionModal(props) {

    const versionDetail = useSelector((state) => state.invoices.versionDetail);
    const auth = useSelector((state) => state.auth);

    const handleClose = () => {
        props.setVersionModalOpen(false);
        props.clearInvoiceVersionDetail();
    }

    const downloadAttachment = (id, file_name) => {
        const fileDownload = require("js-file-download");
        axios.get(`/v0/api/core/download/${id}/`, {
            responseType: "blob",
            headers: { "Authorization": `Token ${auth.token}` }
        }).then(res => {
            fileDownload(res.data, file_name);
        }).catch(err => {
            console.log(err);
        })
    }

    return (
        <Modal className="extra-wide" blurBack={true} hideLogo={true} hasCloseButton={true} handleClose={handleClose} >
            <div className="modal-content">
                <h1 className="title heavy gap-below-m">
                    Invoice
                    <span className="light g3-text">
                        {versionDetail.invoice_number ? `  ${versionDetail.invoice_number} Version ${versionDetail.version}` : ""}
                    </span>
                </h1>
                {versionDetail.invoice_id
                ? <InvoiceDetailsCard invoice={versionDetail} downloadAttachment={downloadAttachment} />
                : <p className="content1 light-black">Loading version...</p>}
            </div>
        </Modal>
    );
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, { clearInvoiceVersionDetail })(InvoiceVersionModal);
